// Screenshot tabs (WAI-ARIA tabs pattern) and a <dialog> lightbox.

export function initGallery(root: HTMLElement): void {
  const tabs = Array.from(root.querySelectorAll<HTMLButtonElement>('[role="tab"]'));

  const select = (tab: HTMLButtonElement, focus = false) => {
    for (const t of tabs) {
      const on = t === tab;
      t.setAttribute("aria-selected", String(on));
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute("aria-controls") ?? "");
      if (panel) panel.hidden = !on;
    }
    if (focus) tab.focus();
  };

  tabs.forEach((tab, i) => {
    tab.addEventListener("click", () => select(tab));
    tab.addEventListener("keydown", (e) => {
      const move = { ArrowRight: 1, ArrowLeft: -1, Home: -i, End: tabs.length - 1 - i }[e.key];
      if (move === undefined) return;
      e.preventDefault();
      const next = tabs[(i + move + tabs.length) % tabs.length];
      if (next) select(next, true);
    });
  });
}

export function initLightbox(): void {
  const dialog = document.querySelector<HTMLDialogElement>("[data-lightbox]");
  const img = dialog?.querySelector<HTMLImageElement>("[data-lightbox-img]");
  if (!dialog || !img || typeof dialog.showModal !== "function") return;

  document.querySelectorAll<HTMLButtonElement>("[data-zoom]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const source = btn.querySelector("img");
      if (!source) return;
      img.src = source.currentSrc || source.src;
      img.alt = source.alt;
      dialog.showModal();
    });
  });

  // Clicking the backdrop (the dialog itself, outside the image) closes it.
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) dialog.close();
  });
}
